import React, { useState, useMemo, useCallback, useEffect } from 'react';
import styles from './Card.module.scss';
// import IconPencil from 'src/assets/icons/pencil.svg?react';
import MarkCheckIcon from 'src/assets/icons/mark_check.svg?react';
import InprogressIcon from 'src/assets/icons/mark_inprogress.svg?react';
import { Unit } from '../../../../types';
import { getMediaAbsolutePath } from '../../../../services/File';
import { formatDate } from '@src/utils/time';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { IconInfo } from '@src/constants';
import { Popover } from 'antd';
import './customStyle.css';
import CoverVideoPlayer from '@src/components/unit-progress-modal/cover-video/VideoPlayer';
import OverviewForm from './overview/OverviewForm';
import { useGetUnitQuickInfoLazyQuery } from '@src/api/graphql-codegen';

type Props = {
  unit: Unit
  handleEditUnit: (unit: Unit) => void
  handleOpenUnit?: (unit: Unit) => void
  handleCardHovered?: (unitId: string, hovered: boolean) => void
  handleSelectedCenterCard?: (centerCard: boolean) => void
  cardHovered?: boolean;
  hoveredUnitId?: string | ""
  index: number
  isSelected?: boolean
  programID?: string | "";
}

function Card(props: Props) {
  const [isHovered, setIsHovered] = useState(false);
  const { index, unit, cardHovered = false, hoveredUnitId, isSelected = false, programID, handleOpenUnit, handleCardHovered, handleSelectedCenterCard } = props

  const completedPercent = useMemo(() => {
    let percent = 0
    if (unit.progress) {
      percent = unit.progress;
    }
    return percent
  }, [unit])

  const newLabelStyle = useMemo(() => {
    const classes = [styles.labelContainer];
    if (unit.newLabelPosition === 'tl') {
      classes.push(styles.tlComingSoonLabel);
    } else if (unit.newLabelPosition === 'tr') {
      classes.push(styles.trComingSoonLabel);
    } else if (unit.newLabelPosition === 'bl') {
      classes.push(styles.blComingSoonLabel);
    } else if (unit.newLabelPosition === 'br') {
      classes.push(styles.brComingSoonLabel);
    }
    return classes.join(' ');
  },[unit])

  const updatedLabelStyle = useMemo(() => {
    const classes = [styles.labelContainer];
    if (unit.updatedLabelPosition === 'tl') {
      classes.push(styles.tlComingSoonLabel);
    } else if (unit.updatedLabelPosition === 'tr') {
      classes.push(styles.trComingSoonLabel);
    } else if (unit.updatedLabelPosition === 'bl') {
      classes.push(styles.blComingSoonLabel);
    } else if (unit.updatedLabelPosition === 'br') {
      classes.push(styles.brComingSoonLabel);
    }
    return classes.join(' ');
  },[unit])

  const comingSoonLabelStyle = useMemo(() => {
    const classes = [styles.labelContainer];
    if (unit.comingSoonLabelPosition === 'tl') {
      classes.push(styles.tlComingSoonLabel);
    } else if (unit.comingSoonLabelPosition === 'tr') {
      classes.push(styles.trComingSoonLabel);
    } else if (unit.comingSoonLabelPosition === 'bl') {
      classes.push(styles.blComingSoonLabel);
    } else if (unit.comingSoonLabelPosition === 'br') {
      classes.push(styles.brComingSoonLabel);
    }
    return classes.join(' ');
  },[unit.comingSoonLabelPosition])

  const comingSoonDate = useMemo(() => {
    if (unit.isComingSoon && unit.comingSoonAt) {
      let d;
      if (unit.comingSoonAt.includes('-')) {
        d = new Date('2023-09-23');
      } else {
        d = new Date(parseInt(unit.comingSoonAt));
      }
      var dateString = formatDate(d.valueOf(), 'MMM dd, yyyy')
      return dateString;
    } else {
      return ''
    }
  }, [unit.isComingSoon, unit.comingSoonAt])

  const [getUnitQuickInfo, {data, loading}] = useGetUnitQuickInfoLazyQuery({ fetchPolicy: 'network-only'})

  useEffect(() => {
    if (cardHovered && hoveredUnitId === unit.id && isSelected) {
      getUnitQuickInfo({
        variables: {
          input: { id: unit.id }
        }
      })
    }
  }, [cardHovered, hoveredUnitId, isSelected, unit.id, getUnitQuickInfo])

  const onClickUnit = useCallback(() => {
    handleOpenUnit?.(unit)
  }, [handleOpenUnit, unit])

  const handleHover = useCallback((hover: boolean) => {
    if(handleCardHovered) {
      handleCardHovered(unit.id, hover)
    }
  }, [handleCardHovered, unit])

  const handleClickUnitInfo = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    handleHover(true)
    handleSelectedCenterCard?.(index % 3 === 2)
  }, [handleHover, handleSelectedCenterCard, index])

  const numberOfLessons = useMemo(() => {
    if (data?.getUnitInfo) {
      return (data?.getUnitInfo.alternateMaterialsCount ?? 0) + (data?.getUnitInfo.classPresentationCount ?? 0) + (data?.getUnitInfo.teacherPreparationCount ?? 0);
    }
    return 0    
  }, [data?.getUnitInfo])

  const content = (
    <div className={styles.unitInfoView}>
      <div  className={styles.coverView}>
        <CoverVideoPlayer src={unit?.popupCover} playing={true} metaData={{video_title: 'Cover Video'}} />
      </div>
      <div className={styles.overview}>
          <div className={styles.overviewSubView}>
            <div className={styles.subTitle}>{unit.name} - Unit Overview</div>
            <OverviewForm unit={unit} numberOfLessons={numberOfLessons} loading={loading}/>
          </div>
        </div>
    </div>
  );

  return (
    <Popover placement={index % 3 === 1 ? "rightTop" : index % 3 === 2 ? "bottom" : "leftTop"} 
      title={''} content={content} open={cardHovered && hoveredUnitId === unit.id && isSelected}>
      <div id={`${programID}_${unit.id}`} className={`${(isHovered && !cardHovered) ? styles.cardHovered : cardHovered ? styles.quickHoverCard : styles.card}`} onClick={onClickUnit} onMouseOver={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}
        style={{ backgroundImage: `url(${unit.coverImage ? getMediaAbsolutePath(unit.coverImage) : ''})`, zIndex: (cardHovered && hoveredUnitId === unit.id && isSelected) ? 2 : 0 }}>
        {completedPercent === 100 ?
            <div className={styles.completeIcon}>
              <MarkCheckIcon className={styles.normal} width={26} height={26}/>
            </div>  
            : <div>
              {(completedPercent > 0) && <InprogressIcon className={styles.inprogressBadge} width={34} height={34} />}
            </div>
          }
        {(completedPercent > 0) &&<div className={styles.progressBackBar}><div className={styles.progressBar} style={{width: `${completedPercent}%`, backgroundColor: completedPercent === 100 ? "#62C590" : "#62C590", borderBottomRightRadius: completedPercent === 100 ? "3px" : "0" }}></div></div>}
        {unit.isNew && <div className={newLabelStyle}>
          NEW
        </div>}
        {unit.isUpdated && <div className={updatedLabelStyle}>
          UPDATED
        </div>}
        {unit.isComingSoon && <div className={comingSoonLabelStyle}>
          UPDATE COMING {comingSoonDate}
        </div>}
        
        {programID && <div className={styles.iconWrapper} onClick={handleClickUnitInfo}>
          <LordIcon src={IconInfo} isHover={true} colors={{primary: '#FFFFFF', secondary: '#FFFFFF'}} size={26}/>
        </div>}
      </div>
    </Popover>
  );
}

export default Card

